import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StepperType } from "../../models/stepper";

export interface StepperState {
  currentStep: number;
  completedSteps: number[];
  flow?: StepperType;
}

const initialState: StepperState = {
  currentStep: 0,
  completedSteps: [],
};

const stepperState = createSlice({
  name: "stepper",
  initialState,
  reducers: {
    resetStepperState: () => {
      return initialState;
    },
    setCurrentStep: (state, action: PayloadAction<number>) => {
      if (action.payload === 0) return initialState;
      state.completedSteps.push(state.currentStep);
      state.currentStep = action.payload;
    },
    setNextStep: (state) => {
      state.completedSteps.push(state.currentStep);
      state.currentStep++;
    },
    setFlow: (state, action: PayloadAction<StepperType>) => {
      state.flow = action.payload;
      state.currentStep = 1;
      state.completedSteps = [0];
    },
  },
});

export const { setCurrentStep, setFlow, resetStepperState, setNextStep } = stepperState.actions;
export default stepperState.reducer;
